import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Phone } from "lucide-react";

export default function ThankYou() {
  const [params] = useSearchParams();
  const score = params.get("score") || "Warm";
  return (
    <section className="py-24 min-h-[70vh] bg-offwhite" data-testid="thank-you-page">
      <div className="mx-auto max-w-2xl px-4 text-center">
        <div className="inline-flex bg-money text-white rounded-full h-16 w-16 items-center justify-center mb-6">
          <CheckCircle2 size={32} />
        </div>
        <h1 className="font-display text-4xl sm:text-5xl text-navy">We got it.</h1>
        <p className="mt-4 text-lg text-navy-800">
          A member of the Aspire Collective Partners LLC team will call you within <strong>24 hours</strong> with your no-obligation cash offer.
        </p>
        <p className="mt-2 text-sm text-muted">Watch for a call from an unknown number — that's us. Check your email/text for confirmation.</p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a href="tel:+16149664283" className="h-14 px-6 rounded-md bg-money text-white font-bold flex items-center gap-2" data-testid="thankyou-call-btn">
            <Phone size={18} /> Or call us now: (614) 966-4283
          </a>
          <Link to="/" className="h-14 px-6 rounded-md border-2 border-navy text-navy font-bold flex items-center" data-testid="thankyou-home-link">
            Back to home
          </Link>
        </div>
        <p className="mt-4 text-sm text-navy-800">
          Or email us: <a href="mailto:carlos@aspirecollectivepartnersllc.com" className="text-money font-semibold" data-testid="thankyou-email-link">carlos@aspirecollectivepartnersllc.com</a>
        </p>
        <p className="mt-8 text-xs text-muted">Reference score: {score}</p>
      </div>
    </section>
  );
}
